import { render, staticRenderFns } from "./SampleSpinner.vue?vue&type=template&id=3f85590f"
import script from "./SampleSpinner.vue?vue&type=script&lang=js"
export * from "./SampleSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f85590f')) {
      api.createRecord('3f85590f', component.options)
    } else {
      api.reload('3f85590f', component.options)
    }
    module.hot.accept("./SampleSpinner.vue?vue&type=template&id=3f85590f", function () {
      api.rerender('3f85590f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/loaders/SampleSpinner.vue"
export default component.exports